import { gql, useMutation } from '@apollo/client';
import { Pda } from './components/Pda';
import { Header } from './components/Header';
import { ArrivalRelatedScanComponent, HandleScanEventResult } from './components/ArrivalRelatedScanComponent';
import { isTrackingNumber, isBagNumber, showTrackingNumberError, showBarCodeError } from '../../utils/BarCodeUtil';
import { t } from '../../i18n';

const HANDLE_RETURN_ARRIVAL_SCAN_EVENT = gql`
   mutation HandleReturnArrivalScanEvent($barCode: String!) {
     success: handleReturnArrivalScanEvent(barCode: $barCode) 
   }
`;

const PageBody = () => {
    const [handleReturnArrivalScanEvent] = useMutation(HANDLE_RETURN_ARRIVAL_SCAN_EVENT);

    const handleScanEvent = async (barCode: string): Promise<HandleScanEventResult> => {
        if (!isTrackingNumber(barCode) && !isBagNumber(barCode)) {
            showBarCodeError(barCode);
            return { success: false };
        }
        const { data } = await handleReturnArrivalScanEvent({ variables: { barCode } });
        return { success: data?.success || false };
    };
    return (
        <ArrivalRelatedScanComponent
         value1Placeholder={t('pda.pages.returnArrival.bagCodeTrackingNo')}
         value1ColumnTitle={t('pda.common.bagPackage')}
         handleScanEvent={handleScanEvent} />
    );
}

export default function ReturnArrivalPage() {
    return (
        <div className="w-full h-full flex flex-col gap-2 p-2">
            <Header title={t('pda.pages.returnArrival.returnArrivalScan')}/>
            <Pda/>
            <PageBody/>
        </div>
    );
} 